import styled from '@emotion/styled'

const Overlay = styled.div<{ breakpoint: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  z-index: 9999;
  display: none;
  align-items: center;
  justify-content: center;

  @media (max-width: ${({ breakpoint }) =>
      breakpoint - 1}px) and (orientation: portrait) {
    display: flex;
  }
`

const Video = styled.video`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
`

interface UseForceVideoPortraitOptions {
  /**
   * CSS breakpoint in pixels. Video will show when width is less than this value.
   * @default 768
   */
  breakpoint?: number
  /**
   * Path to the video file
   * @default '/videos/rotatePhone.mp4'
   */
  videoSrc?: string
}

export const useForceVideoPortrait = (
  options: UseForceVideoPortraitOptions = {}
) => {
  const { breakpoint = 768, videoSrc = '/videos/rotatePhone.mp4' } = options

  return (
    <Overlay breakpoint={breakpoint}>
      <Video src={videoSrc} autoPlay loop muted playsInline preload="auto" />
    </Overlay>
  )
}
